"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faArrowDown_1 = require("@fortawesome/pro-regular-svg-icons/faArrowDown");
var StatsBadge_1 = __importDefault(require("atomicComponents/atoms/Badge/StatsBadge"));
var SuccessStatsBadge = function (_a) {
    var label = _a.label, size = _a.size;
    return ((0, jsx_runtime_1.jsx)(StatsBadge_1.default, { color: "success", icon: faArrowDown_1.faArrowDown, label: label, size: size }));
};
exports.default = SuccessStatsBadge;
